module.exports = __webpack_public_path__ + "static/media/ic-mob-add-pic.d48c0013.svg";